import React from 'react'
import { Level, LevelLeft, LevelItem, LevelRight } from '../layouts/Level'
import Button from '../buttons/Button'

const Toolbar = ({ children, onAdd }) => (
  <Level className="is-mobile">
    <LevelLeft>
      <LevelItem>
        {children}
      </LevelItem>
    </LevelLeft>

    <LevelRight>
      <LevelItem>
        <Button className="is-success" onClick={onAdd}>
          New
        </Button>
      </LevelItem>
    </LevelRight>
  </Level>
)

export default Toolbar



// WEBPACK FOOTER //
// ./src/components/views/listview/Toolbar.js